import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SalesPage from 'components/landingPages/SalesPage';

function mapStateToProps(state, ownProps) {
  return {
    signupReducer: state.signupReducer
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: {
      signUpActions: bindActionCreators(require('actions/signUpActions'), dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SalesPage);


// WEBPACK FOOTER //
// ./src/containers/SalesPageContainer.js